// extracted by mini-css-extract-plugin
export default {"item-blog":"BlogStyles_item-blog__Y5CGV"};